import "../../../App.css";
import Header from "../../../components/Header";
import Footer from "../../../components/Footer";
import BackOnly from "../../../components/BackOnly";
import ContactPopup from "../../../components/ContactPopup";
import React, { useState, useEffect } from "react";

import { useNavigate } from "react-router-dom";   // ⭐ REQUIRED

import AffiliateBooking from "../../../components/affiliate/AffiliateBooking";
import AffiliateExpedia from "../../../components/affiliate/AffiliateExpedia";
import AffiliateTrip from "../../../components/affiliate/AffiliateTrip";

// ⭐ STRICT COMMAND: Idaho ALWAYS goes back to USA map
export const backRoute = "/map/usa";

export default function Idaho() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  // ⭐ Send strict back command to BackOnly
  useEffect(() => {
    navigate(".", { state: { backRoute } });
  }, [navigate]);

  return (
    <>
      <Header />

      <div className="visited-back-wrapper">
        <BackOnly />
      </div>


      <div className="page-container" style={{ padding: "10px" }}>
        <h1>Idaho</h1>

        <section className="travel-review">
          {/* LEFT COLUMN */}
          <div className="travel-text">
            <h2>🌉 Discover Idaho</h2>

            <p>
              Known as the "Gem State," Idaho is a treasure trove of outdoor adventure.
              Its landscapes are as varied as they are breathtaking — jagged peaks in the
              Sawtooth Range, dense forests, winding rivers, and the wide, golden plains
              of the Snake River Valley. Whether you're hiking alpine trails, casting a
              line in glacier-fed waters, skiing powdery slopes, or simply soaking in
              panoramic views, Idaho offers something for every kind of explorer.
              Idaho’s most iconic crop. Drive through the state and you’ll see fields
              stretching to the horizon, rich with rows of green. Thanks to its volcanic
              soil, clean mountain water, and ideal climate, Idaho produces more potatoes
              than any other state, contributing significantly to the U.S. supply. It’s
              not just agriculture — it’s heritage.
            </p>

            <h3>🚗 Getting There</h3>

            <p>
              To get to Idaho, you can fly into one of its major airports, such as Boise
              Airport (BOI) or Idaho Falls Regional Airport (IDA). Alternatively, you can
              drive into the state via major highways like Interstate 84, which connects
              Idaho to Oregon and Utah.
            </p>

            <h3>🌟 My Personal Observation</h3>

            <ul>
              <li>
                <div className="place-block">
                  <strong>Shoshone Falls:</strong> The Shoshone Falls, often called the
                  "Niagara of the West," is a stunning waterfall located on the Snake River
                  near Twin Falls, Idaho. It is actually higher than Niagara Falls, with a
                  height of 212 feet (65 meters). The falls are particularly impressive in
                  the spring when water flow is at its peak due to snowmelt.
                  <br />
                  <a
                    href="https://www.google.com/maps?q=42.593683714481614,-114.40163704506685"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📍 View on Google Maps
                  </a>
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Perrine Memorial Bridge:</strong> The iconic bridge in Twin Falls,
                  perfect for bungee jumping and stunning views of the Snake River Canyon.
                  When I visited years ago, I saw several BASE jumpers leaping off the
                  bridge — thrilling to watch.
                  <br />
                  <a
                    href="https://www.google.com/maps?q=42.599292119045,-114.4543628365064"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📍 View on Google Maps
                  </a>
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>The Idaho Falls Town:</strong> A charming town with a beautiful
                  riverwalk, local shops, and restaurants. The falls are illuminated at
                  night, creating a magical atmosphere.
                  <br />
                  <a
                    href="https://www.google.com/maps?q=43.49344041158691,-112.04452669600319"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📍 View on Google Maps
                  </a>
                </div>
              </li>
            </ul>

            <h3>🥾 Other Hidden Gems – Idaho</h3>

            <ul>
              <li>
                <div className="place-block">
                  <strong>Thousand Springs State Park:</strong> A surreal mix of waterfalls,
                  turquoise pools, and lava rock formations.
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>City of Rocks National Reserve:</strong> Granite spires ideal for
                  hiking, climbing, and stargazing.
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Mesa Falls Scenic Byway:</strong> A forested route with two dramatic
                  waterfalls and a historic lodge overlook.
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Craters of the Moon:</strong> Lunar-like lava landscapes offering
                  eerie silence and stunning sunrises.
                </div>
              </li>
            </ul>

            <h3>🛏️ Places to Stay – Idaho Falls</h3>

            <p>
              I stayed at <strong>Shilo Inn Idaho Falls</strong> and{" "}
              <strong>Residence Inn by Marriott</strong>, both right along the river.
              The views were magnificent, the rooms spotless, and the customer service
              top-notch.
            </p>

            <ul>
              <li>
                <div className="place-block">
                  <strong>SpringHill Suites by Marriott:</strong> Modern rooms with riverwalk
                  access.
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Hilton Garden Inn Idaho Falls:</strong> Balconies overlooking the
                  Snake River.
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Best Western Driftwood Inn:</strong> Complimentary bikes and
                  riverside views.
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Clarion Inn Idaho Falls Riverfront:</strong> Budget-friendly and
                  well located.
                </div>
              </li>
            </ul>

           <h3>If you are looking for a place to stay, you can check prices, date and time here.</h3>
                       <div className="affiliate-block">
                         <AffiliateExpedia />
                         <AffiliateBooking />
                         <AffiliateTrip />
                       </div>

            <h3>🎥 My Travel Videos</h3>

            <p>
              Here are some videos I took from the Shoshone Falls. Be sure the quality is set to
              1080p or higher, hope you enjoy them!
            </p>

            <p>
              <a
                href="https://youtu.be/CTqPwTs1P1U?si=vIxzSgYLVjz7bNdq"
                target="_blank"
                rel="noopener noreferrer"
              >
                Shoshone Falls
              </a>
            </p>
          </div>

          {/* RIGHT COLUMN */}
          <div className="travel-image-column">

            {/* RESTORED VIDEO THUMBNAIL */}
            <a
              href="https://youtu.be/CTqPwTs1P1U?si=vIxzSgYLVjz7bNdq"
              target="_blank"
              rel="noopener noreferrer"
              className="youtube-image-card"
            >
              <img
                src="/images/usa/idaho/shoshonefalls.jpg"
                alt="Shoshone Falls Video Thumbnail"
              />
            </a>

            {/* ALL YOUR IMAGES EXACTLY AS YOU PROVIDED */}
            <img src="/images/usa/idaho/perrinememorialbridge.jpg" alt="Perrine Memorial Bridge" />
            <img src="/images/usa/idaho/bridgejumps.jpg" alt="Perrine Memorial Bridge Jumps" />
            <img src="/images/usa/idaho/snakeriver.jpg" alt="Snake River" />
            <img src="/images/usa/idaho/snakeriver2.jpg" alt="Another View of Snake River" />
            <img src="/images/usa/idaho/thecliff.jpg" alt="The Cliff" />
            <img src="/images/usa/idaho/idahotwinsfallsriver.jpg" alt="Idaho Falls River" />
            <img src="/images/usa/idaho/idahotwinsfalls.jpg" alt="Idaho Falls" />
            <img src="/images/usa/idaho/idahofallsriver.jpg" alt="Idaho Falls River" />
            <img src="/images/usa/idaho/theparadise.jpg" alt="Beautiful Sunset" />
            <img src="/images/usa/idaho/idahofallsriver2.jpg" alt="Idaho Falls River view" />
             <img src="/images/usa/idaho/idahofallsriver3.jpg" alt="Idaho Falls River view" />
            <img src="/images/usa/idaho/river.jpg" alt="The River" />
            <img src="/images/usa/idaho/rainbowatshoshone.jpg" alt="Rainbow at Shoshone Falls" />
            <img src="/images/usa/idaho/shoshonefallsclose.jpg" alt="Shoshone Falls Close-up" />
            <img src="/images/usa/idaho/shoshone3.jpg" alt="Another View of Shoshone Falls" />
          </div>
        </section>
      </div>

      <div className="email-wrapper">
        <button className="email-link" onClick={() => setOpen(true)}>
          contact@thefindingspot.com
        </button>
      </div>

      <ContactPopup isOpen={open} onClose={() => setOpen(false)} />

      <Footer />
    </>
  );
}
